"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtnAction = void 0;
var icons_1 = require("@lift/assets/dist/assets/globals/icons");
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
var BtnAction = function (_a) {
    var id = _a.id, className = _a.className, onClick = _a.onClick, textCustom = _a.textCustom, disabled = _a.disabled;
    return (react_1.default.createElement(styles_1.ButtonStyled, { id: id, className: className, onClick: onClick, disabled: disabled }, textCustom ? (react_1.default.createElement(styles_1.TextStyled, { disabled: disabled, className: "text" }, "C")) : (react_1.default.createElement(LftIconBase_1.default, { icon: icons_1.ArrowRight, size: "md", className: "icon" }))));
};
exports.BtnAction = BtnAction;
